import { Button } from "PFComponents/button";
import { Icon } from "PFComponents/icon";
import { CustomValue } from "PFTypes";
import React from "react";

import { useSkillManagementSidePanel } from "../hooks/use_skill_management_side_panel";
import css from "./skill_title_button.module.scss";

type SkillTitleProps = {
  skill: CustomValue;
};

export const SkillTitleButton = ({ skill }: SkillTitleProps) => {
  const { openSidePanel } = useSkillManagementSidePanel();

  const isGlobal = skill.global_id !== null;

  return (
    <span className={css.wrapper}>
      <Button text={String(skill.value)} kind="text" onClick={() => openSidePanel(skill.id)} />
      {isGlobal && <Icon name="pf-logo" size="md" />}
    </span>
  );
};
